import { ConnectComponent } from "util";
import View from "./view";
import Presenter from "./presenter";

export default ConnectComponent(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/registration/category/list/form/index.js